import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { getStatusCancelOrder, OrderHistory, OrderHistoryActions } from '@monorepo-channels/channels/domain'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { map, take } from 'rxjs'
import { SuccessCancelOrderComponent } from './success-cancel-order.component'

@Component({
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatIconModule, MatButtonModule],
	selector: 'feature-porto-bank-cancel-order',
	template: `
		<section
			style="padding: 16px; display: flex; flex-direction: column; align-items: flex-start; gap: 16px;"
		>
			<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
				<mat-icon svgIcon="porto-bank-icons:alert"></mat-icon>

				<mat-icon
					svgIcon="porto-bank-icons:close-circle"
					(click)="close()"
					style="cursor: pointer;"
				></mat-icon>
			</div>

			<h1 style="font-size: 22px; font-weight: 600; color: #000;">
				Cancelar {{ order.originalIntent === 'checkin' ? 'check-in' : 'reserva' }}
			</h1>

			<p style=" padding-right: 20px; color: #000;">
				Tem certeza que deseja cancelar
				{{ order.originalIntent === 'checkin' ? 'o check-in' : 'a reserva' }}?
			</p>

			<article class="order-card">
				<h2 class="order-card__name">{{ order.venue.name }}</h2>

				<p class="order-card__location">
					{{ order.venue.address.value }}
				</p>

				<div class="order-card__time">
					<p>
						<span>Data:</span>
						<span style="width: 40%;">{{ order.reservationDateTime | date: 'dd/MM/YYYY' }}</span>
					</p>
					<p>
						<span>Horário:</span> <span>{{ order.reservationDateTime | date: 'HH:mm' }}</span>
					</p>
				</div>
			</article>

			<div style="display: flex; gap: 8px; align-self: flex-end; margin-top: 16px;">
				<button
					mat-button
					(click)="dialogRef?.close()"
					style="background-color: transparent; color: var(--content-primary); font-weight: 600; font-size: 15px; max-width: 55px; height: 30px; border: 1px solid var(--content-primary);"
				>
					Não
				</button>

				<button
					mat-button
					(click)="cancelOrder()"
					style="background-color: var(--content-primary); color: white; font-weight: 600; font-size: 15px; max-width: 55px; height: 30px"
				>
					Sim
				</button>
			</div>
		</section>
	`,
	styles: `
		.order-card {
			display: flex;
			flex-direction: column;
			gap: 12px;
			background-color: #fff;
			border-radius: 8px;
            border: 1px solid #E0E0E0;
            padding: 20px;

			&__name {
				font-size: 20px;
				font-weight: 500;
				overflow: hidden;
				color: var(--content-title);
				white-space: nowrap;
				@media (max-width: 375px) {
					width: 200px;
					text-overflow: ellipsis;
				}
			}

            &__time{
                background-color: #EAECF6;
                padding: 16px;
                font-size: 12px;
                font-weight: 480;
                margin: 0 -20px;
                margin-bottom: -20px;
                color: #3C3C3C;
                p{
                    display: flex;
                    gap: 20px;
                    span{
                        width: 20%;
                    }
                }
            }

			&__location {
				font-size: 16px;
				color: var(--content-title);
				font-weight: 400;
			}
		}
	`,
})
export class CancelOrderComponent {
	private store = inject(Store)
	private actions$ = inject(Actions)
	public loading$ = this.store.select(getStatusCancelOrder).pipe(map(status => status === 'pending'))
	private dialog = inject(MatDialog)
	public dialogRef = inject(MatDialogRef, { optional: true })
	public order: OrderHistory = inject(MAT_DIALOG_DATA, { optional: true })

	cancelOrder() {
		if (this.dialogRef) this.dialogRef.disableClose = true

		this.store.dispatch(OrderHistoryActions.cancelOrder({ orderId: this.order.id }))
		this.actions$.pipe(ofType(OrderHistoryActions.cancelOrderSuccess), take(1)).subscribe(() => {
			this.dialogRef?.close()
			this.dialog.open(SuccessCancelOrderComponent, {
				data: this.order,
				width: '400px',
			})
		})
	}

	close() {
		this.dialogRef?.close()
	}
}
